import styled, { css } from 'styled-components';

import Button from '../_Button';
import Loader from '../../loader/Loader';

export const StyledButton = styled(Button)<{
  busy?: boolean;
  fullWidth?: boolean;
  $wrap?: boolean;
}>`
  height: ${({ $wrap }) => $wrap ? 'auto' : '50px'};
  font-size: 17px;
  font-weight: 700;
  background: transparent;
  color: ${({ theme }) => theme.colors.primary};
  padding: ${({ $wrap }) => $wrap ? '12px ' : '0 '} 32px;
  border-radius: ${({ theme }) => theme?.SecondaryButton?.borderRadius || theme?.Button?.borderRadius};
  line-height: ${({ $wrap }) => $wrap ? 'inherit' : '46px'};

  a& {
    line-height: ${({ $wrap }) => $wrap ? 'inherit' : '49px'};
  }

  &:after {
    content: '';
    border-radius: ${({ theme }) => theme?.SecondaryButton?.borderRadius || theme?.Button?.borderRadius};
    border: 2px solid ${({ theme }) => theme.colors.buttonBorder};
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
  }

  &:hover {
    color: ${({ theme }) => theme?.SecondaryButton?.hoverColor || theme.colors.primary};

    &:after {
      ${({ theme, busy }) => !busy && theme?.SecondaryButton?.hoverBorderWidth && `border-width: ${theme.SecondaryButton.hoverBorderWidth}px`};
      border-color: ${({ theme }) => theme?.SecondaryButton?.hoverBorderColor || theme.colors.primary};
    }
  }

  &[disabled], &:disabled {
    background: ${({ theme }) => theme?.SecondaryButton?.disabledBackground || theme.colors.disabled};
    color: ${({ theme, busy }) => busy ? 'transparent' : theme?.SecondaryButton?.disabledColor || theme.colors.white};
    font-style: ${({ busy, theme }) => busy ? 'normal' : theme?.Button?.disabledFontStyle};
    cursor: default;

    &:after {
      border-color: ${({ theme }) => theme?.SecondaryButton?.disabledBorderColor || theme.colors.disabled};
    }
  }

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }

  &:active:not(:disabled) {
    color: ${({ theme }) => theme?.SecondaryButton?.activeColor || theme.colors.dark};

    &:after {
      ${({ theme, busy }) => !busy && theme?.SecondaryButton?.activeBorderWidth && `border-width: ${theme.SecondaryButton.activeBorderWidth}px`};
      border-color: ${({ theme }) => theme?.SecondaryButton?.activeBorderColor || theme.colors.primary};
    }
  }

  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
  `}
`;

export const StyledLoaderWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 9px;
  left: 50%;
  margin-left: -14px;
`;

export const StyledLeftIcon = styled.svg<{ busy: boolean}>`
  position: relative;
  top: 5px;
  margin-right: 12px;
  visibility: ${({ busy }) => busy ? 'hidden' : 'visible'};
`;

export const StyledRightIcon = styled.svg<{ busy: boolean}>`
  position: relative;
  top: 5px;
  margin-left: 12px;
  visibility: ${({ busy }) => busy ? 'hidden' : 'visible'};
`;
